import ModalViewModel from 'infra/ModalViewModel'
import { action, computed, observable, makeObservable } from 'mobx'
import { task } from 'mobx-task'
import JobProgressionStore from 'jobs/progression/JobProgressionStore'
import Job from 'jobs/Job'
import { AlertFactory } from 'alerts/Alert'

let entryIdCounter = 0

export class StateEstimatedTaxPaymentEntry {
  readonly id = ++entryIdCounter
  @observable state = ''
  @observable amount: number = 0

  constructor() {
    makeObservable(this)
  }

  @computed
  get isCompleted() {
    return this.state !== ''
  }
}

export class EstimatedIrsPaymentDialogViewModel extends ModalViewModel {
  constructor(
    private progressionStore: JobProgressionStore,
    private job: Job,
    private newAlert: AlertFactory,
  ) {
    super()
    makeObservable(this)
    this.close$.subscribe(this.reset)
  }

  @observable
  federalAmount: number = 0

  @observable
  stateEntries: StateEstimatedTaxPaymentEntry[] = []

  @computed
  get hasIncompleteStateEntries() {
    return this.stateEntries.some((e) => !e.isCompleted)
  }

  @action.bound
  addStateEntry() {
    this.stateEntries.push(new StateEstimatedTaxPaymentEntry())
  }

  @action.bound
  removeStateEntry(index: number) {
    this.stateEntries.splice(index, 1)
  }

  @action.bound
  reset() {
    this.federalAmount = 0
    this.stateEntries = []
  }

  submit = task.resolved(async () => {
    if (this.hasIncompleteStateEntries) return

    const amountByState = this.stateEntries.map((e) => ({
      state: e.state,
      amount: e.amount,
    }))

    try {
      await this.progressionStore.setExtensionAcceptedProgression(this.job.id, {
        federalAmount: this.federalAmount,
        amountByState,
      })
      this.close()
    } catch (err) {
      this.newAlert().fromError(err).show()
    }
  })
}
